module.exports = __webpack_public_path__ + "img/galgos.9144a8bd.svg";